export default {
    XLS: "XLS",
    CSV: "CSV"
}